import React, { useEffect } from 'react';
import styled from 'styled-components';
import { yupResolver } from '@hookform/resolvers';
import { Controller, useForm } from 'react-hook-form';
import { Button } from '@material-ui/core';
import { useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import ReactInputMask from 'react-input-mask';
import { BottomControls, ControlRow } from './WikiDetails';
import { InputTextWithLabel } from '../../../molecules';
import { ContactSchema } from './schema';
import { useAddWikiContactMutation, useUpdateWikiContactMutation } from '../../../redux/rtkQuery/apiWikiSlice';
import { objectKeysToSnakeCase } from '../../../utils';
import { RootState } from '../../../redux/root';
import { JuriContactType } from '../../../api/jurisdiction';
import { setSelectedContact, setSelectedJurisdiction } from '../../../redux/slices/wikiSlice';

const AddContactForm = ({ setShow }) => {
  const { wikiId } = useParams();
  const juri = useSelector((s: RootState) => s.wikiSlice.selectedJurisdiction);
  const selectedContact = useSelector((s: RootState) => s.wikiSlice.selectedContact);
  const dispatch = useDispatch();
  const [addWikiContact] = useAddWikiContactMutation();
  const [updateWikiContact] = useUpdateWikiContactMutation();
  const { register, handleSubmit, getValues, control, setError, errors, formState, reset } = useForm<JuriContactType>({
    resolver: yupResolver(ContactSchema),
    defaultValues: {} as JuriContactType,
  });

  useEffect(() => {
    if (selectedContact && Object.keys(selectedContact).length > 0) {
      reset(selectedContact);
    }
  }, [selectedContact]);
  const onSubmit = async data => {
    if (selectedContact && Object.keys(selectedContact).length === 0) {
      const result = await addWikiContact(objectKeysToSnakeCase({ ...data, jurisdiction: wikiId }));
      const _juri = {
        ...juri,
        contacts: [...juri.contacts, result.data],
      };
      dispatch(setSelectedJurisdiction(_juri));
    } else {
      // Updating the contact
      const _result = await updateWikiContact(objectKeysToSnakeCase({ ...data, id: selectedContact.id, jurisdiction: wikiId }));
      const _juri = {
        ...juri,
        contacts: juri.contacts.map(c => {
          if (c.id === _result.data.id) {
            return _result.data;
          }
          return c;
        }),
      };
      dispatch(setSelectedJurisdiction(_juri));
    }
    dispatch(setSelectedContact({} as JuriContactType));
    setShow(false);
  };

  return (
    <Wrapper>
      <form onSubmit={handleSubmit(onSubmit)} autoComplete="off" aria-autocomplete="none">
        <ControlRow>
          <InputTextWithLabel isRequired inputRef={register} error={errors.contactName} name="contactName" label="Contact Name" />
        </ControlRow>
        <ControlRow>
          <InputTextWithLabel isRequired inputRef={register} error={errors.email} name="email" label="Email" />
          <Controller
            control={control}
            defaultValue=""
            name="phone"
            render={props => (
              <ReactInputMask
                mask="999-999-9999"
                maskChar=" "
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...props}
              >
                {() => <InputTextWithLabel error={errors.phone} label="Phone" />}
              </ReactInputMask>
            )}
          />
        </ControlRow>
        <ControlRow>
          <InputTextWithLabel isRequired inputRef={register} error={errors.contactType} name="contactType" label="Contact Type" />
        </ControlRow>
        <ControlRow>
          <InputTextWithLabel inputRef={register} error={errors.contactNotes} name="contactNotes" label="Contact Notes" />
        </ControlRow>
        <ControlRow>
          <BottomControls>
            <Button variant="contained" type="submit" color="primary">
              Save
            </Button>
          </BottomControls>
        </ControlRow>
      </form>
    </Wrapper>
  );
};

export default AddContactForm;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
